/* eslint-disable */
/* eslint-disable import/prefer-default-export */
// This rule should only be disabled whilst there is only one `export` in this file

export const ORDER_DETAILS_POLLING_INTERVAL = 60000; // 60000 ms === 1 minute
